import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-2" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "capitalize" }

import circleProgress from "@/components/template/circleProgress.vue"
  interface Props {
    data: {
      archetype: string
      codename: string
      color: string
      description: string
      fear: string
      icon: string
      image: string
      image_with_icon: string
      influential_figure: string
      life_quote: string
      motivation: string
      name: string
      problem_solving_mechanism: string
      sneak_peak: string
      pitfalls: string[]
      talents: string[]
    }
    percentage: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorksonaSummary',
  props: {
    data: null,
    percentage: null
  },
  setup(__props: any) {

const props = __props as {
    data: {
      archetype: string
      codename: string
      color: string
      description: string
      fear: string
      icon: string
      image: string
      image_with_icon: string
      influential_figure: string
      life_quote: string
      motivation: string
      name: string
      problem_solving_mechanism: string
      sneak_peak: string
      pitfalls: string[]
      talents: string[]
    }
    percentage: string
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.data)
      ? (_openBlock(), _createBlock(circleProgress, {
          key: 0,
          data: [parseFloat(props.percentage), 100 - parseFloat(props.percentage)],
          colors: [props.data?.color, 'transparent'],
          labels: [props.data?.archetype, 'rest'],
          image: props.data?.icon
        }, null, 8, ["data", "colors", "labels", "image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(props.percentage) + "%", 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.data?.codename), 1)
    ])
  ]))
}
}

})